export const SCREEN_TABS_HISTORY_TYPE = 'SCREEN_TABS' as const;
export const FIELD_HISTORY_TYPE = 'FIELD' as const;
